import Box from '@mui/material/Box'
import { CSSProperties, ReactNode, useState } from 'react'

interface Props {
  button: ReactNode
  children: ReactNode
}

export default function HoverButtonComponent(props: Props) {
  const [hovered, setHovered] = useState(false)

  return (
    <Box
      style={containerStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {props.children}
      {hovered && <Box style={buttonStyle}>{props.button}</Box>}
    </Box>
  )
}

const containerStyle: CSSProperties = {
  position: 'relative',
}

const buttonStyle: CSSProperties = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
}
